// libs
import React, { memo } from 'react';

// styles
import { Image } from './styles';

// context
import { useDomainConfig } from 'shared/domainConfig/context/context';

// constants
import { LOGO_TYPE } from 'shared/constants';
import { getStoreId } from 'shared/store/app/selectors';
import { useSelector } from 'react-redux';
import { DEFAULT_STORE } from 'shared/helpers/storeUrl';

// defs
interface ILogoProps {
  className?: string;
  type: string;
  showLogoOnLeft?: boolean;
  pdpSearchBarEnabled?: boolean;
}

function Logo({ className, type, showLogoOnLeft, pdpSearchBarEnabled }: ILogoProps) {
  const { LOGO, SMALL_LOGO } = useDomainConfig();
  const storeId = useSelector(getStoreId);
  let logo = LOGO;

  if (pdpSearchBarEnabled && type === LOGO_TYPE.MWEB) {
    logo = SMALL_LOGO;
  }

  let WIDTH, HEIGHT, URL;

  if (type === LOGO_TYPE.MWEB && storeId !== DEFAULT_STORE && !showLogoOnLeft) {
    logo = LOGO.DWEB;
    WIDTH = logo.WIDTH;
    HEIGHT = logo.HEIGHT;
    URL = logo.URL;
  } else {
    const logoConfig = logo?.[type] || {};
    WIDTH = logoConfig.WIDTH;
    HEIGHT = logoConfig.HEIGHT;
    URL = logoConfig.URL;
  }

  const { LOGO_ALT_TEXT } = logo;

  return (
    <Image width={WIDTH} height={HEIGHT} src={URL} className={className} alt={LOGO_ALT_TEXT} />
  );
}

export default memo(Logo);
